export default {"src":"/_next/static/media/CAFlag.299716c8.svg","height":24,"width":32};